/**
 * Aqui estan las keys que no deberían  borrarse del storage cuando se cierre la sesión
 */
export const IMPORTANT_STORAGE_KEYS = ["tourCollection", "FavoritesBooks"];

